import { RadioGroup } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useRef, useState } from 'react';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';
import { useStore } from '../../../store';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelCheck from '../../../../../components/extras/SidePanelCheck';
import TableChecks from '../../../../../components/tables/tableChecks';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemCheck } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';


const pageSize = 10;

export const EDVChecksPendingPage = () => {
    const { parameters, menu } = useGlobalState();
    const [filteringText, setFilteringText] = useState("");
    const [counter, setCounter] = useState("");
    const [status, setStatus] = useState("");
    const [currentPageIndex, setCurrentPageIndex] = useState(1);

    const mountedRef = useRef(false);

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();



    const [check, setCheck] = useState<ItemCheck>();
    const [pendings, setPendings] = useState<ItemCheck[]>([]);


    useEffect(() => {
        //handleCheckPending();
    }, []);

    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");

            if (id) {
                if (!mountedRef.current) {
                    handleCheckPending();
                    mountedRef.current = true;
                }
                handleGetCheck(parseInt(id))
            } else {
                handleCheckPending();
            }
        };

        window.addEventListener("hashchange", handleHashChange);
        // also trigger once on mount
        handleHashChange();

        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);



    const handleUpdateCheck = async (checkData = check) => {
        try {

            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/checks/requests/update',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify(checkData)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data && data.status) {
                if (data.code === 0) {
                    //handleCheckPending()
                    //addNotification(data.status, "success", setData);
                    //setCheck(undefined)
                    window.location.hash = "edv/checks/pending";

                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
            addNotification(`Error de red y/o comunicaciones: ${error}`, "error", setData);
        } finally {
            setLoading(false);

        }
    }
    const handleCheckPending = async () => {
        try {
            setPendings([])
            setLoading(true)
            setCheck(undefined)


            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/checks/requests/search',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    pending: true,
                    orderBy: "statusRequest",
                    order: "asc",
                    orderBy2: "dateSubmited",
                    order2: "desc",
                    columns: "[check], dateAssigned, idCheck, idRequest, idInstructor, keyw, displayName, instructorCheck, statusRequest, equipmentCheck, category, instructor, dateResult, dateAssigned, dateSubmited"
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setPendings(data.checks);

            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }


    const handleGetCheck = async (id: number) => {
        try {
            //console.log("FETCH PENDING")
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/checks/requests/get',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ idRequest: id }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                if (data.check)
                    setCheck(data.check);

            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    type Tab = {
        label: string;
        id: string;
        content: React.ReactNode;
    };

    const filteredChecks = pendings.filter(check => {
        const matchesStatus = status === "" || check.statusRequest.toString() === status;

        return matchesStatus;
    });

    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={check !== undefined}
            onSplitPanelToggle={({ detail }) => {
                if (!detail.open) {
                    //setCheck(undefined);
                    window.location.hash = "#edv/checks/pending"
                }
            }
            }
            splitPanelSize={600}
            splitPanel={
                <SidePanelCheck editIntructor={check && (check.statusRequest === 1 || check.statusRequest === 0)} Check={check} onUpdateCheck={handleUpdateCheck} />

            }
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween direction="vertical" size="xs">

                    {/*
                        counter={pendings.length > 0 ? pendings.length === filteredChecks.length ? pendings.length.toString() : `${filteredChecks.length} de ${pendings.length}` : undefined}
                        */}
                    <Header actions={<Favorites />} description={`Lista de chequeos pendientes de evaluación/asignación`}
                    >
                        Chequeos pendientes
                    </Header>
                    <SpaceBetween direction='vertical' size='xs'>
                        {pendings.length > 0 && (
                            <SpaceBetween direction='vertical' size='xs'>

                                <RadioGroup direction='horizontal'

                                    onChange={({ detail }) => setStatus(detail.value)}
                                    value={status}
                                    items={[
                                        { value: "", label: "Todos" },
                                        { value: "1", label: "Asignados" },
                                        { value: "0", label: "Pendientes" }
                                    ]}
                                />
                                <TableChecks checks={filteredChecks} onSelect={(item: ItemCheck) => window.location.hash = `edv/checks/pending?id=${item.idRequest}`} onCounter={(counter: string) => setCounter(counter)} />
                            </SpaceBetween>
                        )}
                    </SpaceBetween>
                </SpaceBetween>
            }
        />
    );
};

function getColor(hex: string): "green" | "blue" | "red" | "grey" | "severity-low" {
    switch (hex.toLowerCase()) {
        case "#00b000":
            return "green";
        case "#007cff":
            return "blue";
        case "#ff0000":
            return "red";
        case "#999999":
            return "severity-low";
        default:
            return "grey";
    }
}